import useSelector from "src/utils/useSelector";
import { useEffect } from "react";
import { logError } from "src/utils/logger";

export default function useLogChatSettingsError() {
    const isAppOpen = useSelector((state) => state.onlineShopper.isAppOpen);
    const enabled = useSelector((state) => state.account.settings?.electric?.message_center_enabled);
    const missingConversationsConfig = window.DIConversationsConfig === undefined;

    useEffect(() => {
        if (isAppOpen && enabled && missingConversationsConfig) {
            logError("In App Chat is turned on, but required Conversations config not found on page.");
        }
    }, [isAppOpen, enabled, missingConversationsConfig]);
}
